import { createValidIcon } from '@ui/icons/utils/type-helper'

export const LessGreaterIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.5166 7.5791C6.73017 7.84095 6.71478 8.2276 6.4707 8.47168L3.80469 11.1377C3.54434 11.398 3.12168 11.398 2.86133 11.1377C2.60123 10.8774 2.60122 10.4556 2.86133 10.1953L5.05664 8L2.86133 5.80469C2.60112 5.54445 2.60133 5.12267 2.86133 4.8623C3.12168 4.60195 3.54434 4.60195 3.80469 4.8623L6.4707 7.52832L6.5166 7.5791ZM13.1377 10.1953C13.3979 10.4556 13.3979 10.8774 13.1377 11.1377C12.8774 11.398 12.4557 11.3979 12.1953 11.1377L9.52832 8.47168C9.26797 8.21133 9.26797 7.78867 9.52832 7.52832L12.1953 4.8623C12.4557 4.60196 12.8773 4.60196 13.1377 4.8623C13.3978 5.12268 13.3979 5.54444 13.1377 5.80469L10.9424 8L13.1377 10.1953Z'
        fill={color}
      />
    </svg>
  )
})
